// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createAllotment, deleteAllotment, getAllotmentApi, updateAllotment } from '../../api/AllotmentApi'; // Adjust the path as needed
// import {  createAllotment, deleteAllotment, getAllotmentApi, updateAllotment } from '../../api/AllotmentApi';

import {
    getAllotmentSuccess,
    getAllotmentFailure,
    createAllotmentSuccess,
    createAllotmentFailure,
    updateAllotmentSuccess,
    updateAllotmentFailure,
    deleteAllotmentSuccess,
    deleteAllotmentFailure,
} from './actions';

// Saga to handle fetching Allotments
function* fetchAllotmentSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getAllotmentApi, action.payload);
        yield put(getAllotmentSuccess(data));
    } catch (error: any) {
        const errorMessage =
            error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(getAllotmentFailure(errorMessage));
    }
}

// // Saga to handle creating a Allotment
function* createAllotmentSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createAllotment, action.payload);
        yield put(createAllotmentSuccess(data));
    } catch (error: any) {
        const errorMessage =
            error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(createAllotmentFailure(errorMessage));
    }
}

// // Saga to handle updating a Allotment
function* updateAllotmentSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateAllotment, action.payload.data, action.payload.id);
        yield put(updateAllotmentSuccess(data));
    } catch (error: any) {
        const errorMessage =
            error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(updateAllotmentFailure(errorMessage));
    }
}

// // Saga to handle updating a Allotment
function* deleteAllotmentSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteAllotment, action.payload.id);
        yield put(deleteAllotmentSuccess(data));
    } catch (error: any) {
        yield put(deleteAllotmentFailure(error.message));
    }
}

export default function* AllotmentSaga() {
    yield takeEvery('GET_ALLOTMENT_REQUEST', fetchAllotmentSaga);
    yield takeEvery('CREATE_ALLOTMENT_REQUEST', createAllotmentSaga);
    yield takeEvery('UPDATE_ALLOTMENT_REQUEST', updateAllotmentSaga);
    yield takeEvery('DELETE_ALLOTMENT_REQUEST', deleteAllotmentSaga);
}
